
export enum RoleType {
  Undefined,
  AnkomstRegistrerare,
  Attestant,
  Revisor
}

